module.exports = {"components.auth.authFooter.linkText.learnMore":"En savoir plus","components.auth.authFooter.linkText.privacy":"Confidentialité","components.auth.authFooter.link.privacy":"https://choosemuse.com/fr/legal/#LaPolitiqueDeConfidentialitéDeInteraxon","components.auth.authFooter.linkText.contactUs":"Contactez-nous"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/fr/components/Auth/AuthFooter/AuthFooter.json
// module id = 792
// module chunks = 0